<template>
  <input class="generated-2" v-model="value" />
</template>

<script lang="ts" setup>
interface Props {
  modelValue: string
}
const props = withDefaults(defineProps<Props>(), {
})

const emits = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (v) => emits('update:modelValue', v),
})
</script>

<style lang="scss" scoped>
.generated-2 {
    border-radius: 1.5rem;
    border-width: 1px;
    border-color: #c1c1c1;
    border-style: solid;
}
</style>
